var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Control")]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.responseData))]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.error))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3242c07c","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/control.vue
// module id = 203
// module chunks = 0